import { render, staticRenderFns } from "./CosmicBodies.vue?vue&type=template&id=68f8c3af&"
var script = {}
import style0 from "./CosmicBodies.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports